import React from "react";
import { Box } from "@mui/system";
import { selectConnections, selectDirect } from "./aircraftSelectors";

import { useAppSelector } from "../../app/hooks";
import { AircraftData } from "../../components/AircraftData";
import { parseDirectTelemetry } from "../../tools/parse";
import { Connection } from "./aircraftSlice";

type ConnectionWithId = Connection & { id: string };

export const FloatingAircraft = () => {
  const yourAircraft = useAppSelector(selectDirect);
  const connectedAircraft = useAppSelector(selectConnections);
  const rowSx = {
    display: "flex",
    justifyContent: "center",
    columnGap: 16,
    p: 1,
  };

  const connections = Object.entries(connectedAircraft).map(([id, connection]) => ({
    ...connection,
    id,
  }));

  const topConnections = connections.slice(0, 5);

  let bottomConnections: ConnectionWithId[] = [];
  if (connections.length > 5) {
    bottomConnections = connections.slice(5, 10);
  }

  return (
    <>
    <Box sx={rowSx}>
      {topConnections.map((connection) => {
        const aircraft = yourAircraft[connection.id];
        const aircraftData = parseDirectTelemetry(aircraft);

        return (
          <Box key={connection.id}>
            <Box
              mb={0.1}
              mx={1}
              sx={{
                width: 433,
              }}
            >
              <AircraftData
                uavId={connection.id}
                flightMode={aircraftData?.flightMode}
                uavState={aircraftData?.uavState}
                stale={aircraftData?.stale}
                controlled
              />
            </Box>
            <Box width={"100%"} />
          </Box>
        );
      })}
    </Box>
    <Box sx={{
      position: 'fixed',
      top: '51%',
      width: '100%'
    }}>

    <Box sx={rowSx}>
      {bottomConnections.map((connection) => {
        const aircraft = yourAircraft[connection.id];
        const aircraftData = parseDirectTelemetry(aircraft);

        return (
          <Box key={connection.id}>
            <Box
              mb={0.1}
              mx={1}
              sx={{
                width: 433,
              }}
            >
              <AircraftData
                uavId={connection.id}
                flightMode={aircraftData?.flightMode}
                uavState={aircraftData?.uavState}
                stale={aircraftData?.stale}
                controlled
              />
            </Box>
            <Box width={"100%"} />
          </Box>
        );
      })}
    </Box>
    </Box>
    </>
  );
};
